import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StepService {

  public editDataDetails: number = 0;
  public subject = new Subject<number>();

  private readonly stepSource = new BehaviorSubject(this.editDataDetails);

  currentStep = this.stepSource.asObservable();

  private readonly knowMyProductSubject = new BehaviorSubject<boolean>(false);
  knowMyProduct$ = this.knowMyProductSubject.asObservable();

  constructor() { }

  changeStep(step: number) {
    this.stepSource.next(step);

  }

  stepKnowProduct(knowMyProduct?: boolean){
    this.knowMyProductSubject.next(knowMyProduct ?? false);
  }
}
